import {createSvgIcon} from '../create-svg-icon';

export const EjectIcon = createSvgIcon(
  <path d="M5 17h14v2H5zm7-12L5.33 15h13.34L12 5zm0 3.6 2.93 4.4H9.07L12 8.6z" />
, 'EjectOutlined');
